import { useQuery, useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";

const api = async (params) => {
  const x = params;

  const form = x.page ? `id_contrato=${x.contrato_id}&page=${x.page}&perPage=${x.perPage}&lineas_conectadas=0&lineas_bajas=0` : `id_contrato=${x.contrato_id}&lineas_conectadas=0&lineas_bajas=0`
  const { data } = await clienteAxios.get(
    `/sucursalVirtual/crm/ventas/listarLineasContrato?${form}`
  );
  return data;
};

const useListarLineas = () => {
  return useMutation(api, {
    onSuccess: (response) => {
      //toast.success("PDF descargado con exito")
      //window.open(response.success.descripcionRespuesta.urlPdf, '_blank')
    },
    onError: (error) => {
      //toast.error(error.response.data.error.detalleRespuesta)
    },
  });
};

export default useListarLineas;
